import { Controller } from "@hotwired/stimulus"
import { reactor } from "../../lib/reactor"

export default class extends Controller {
  static values = { notify: Boolean }

  connect() {
    reactor(this)
  }
}
